// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1igQ2","title":"Images90_title__3hEdL","images":"Images90_images__oeX7U"};